export class MetaRankingModalService {
  private _item: any;
  private _currentIndex: number;
  private _isOpen: boolean = false;

  constructor() {
    this._item = [];
    this._currentIndex = 0;
  }

  get item() {
    return this._item;
  }

  set item(item: any) {
    this._item = item;
  }

  set isOpen(open: boolean) {
    this._isOpen = open;
  }

  get isOpen() {
    return this._isOpen;
  }

  get currentIndex() {
    return this._currentIndex;
  }

  set currentIndex(index: number) {
    this._currentIndex = index;
  }
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-major-explorer/src/modals/metaranking_modal/metaranking_modal_service.ts